"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membershipFactory = exports.membershipPersonaFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
const membership_definition_factory_1 = require("./membership-definition.factory");
const statuses = [
    'Active',
    'Canceled',
    'Requested',
    'Denied',
];
const membershipStatuses = [
    'Pending',
    'Valid',
    'Expired',
];
exports.membershipPersonaFactory = Factory.Sync.makeFactory({
    id: 1,
    first_name: mocks_1.persona.first_name,
    last_name: mocks_1.persona.last_name,
    full_name: `${mocks_1.persona.first_name} ${mocks_1.persona.last_name}`,
    gender: 'male',
    date_of_birth: '1999-09-09',
    email_address: mocks_1.persona.email,
    profile_images: mocks_1.persona.profile_image,
    profile_image_url: 'foo.gif',
});
exports.membershipFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    persona_id: 1,
    label: null,
    status: 'Active',
    membership_status: 'Valid',
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    effective_at: mocks_1.dates.date2000,
    expires_at: mocks_1.dates.date2100,
    purchase_date: mocks_1.dates.date2000,
    affiliation_organization_id: mocks_1.orgClub.id,
    cancel_date: null,
    card_id: Factory.each(i => uuid_1.v4()),
    membership_definition: membership_definition_factory_1.membershipDefinitionFactory.build(),
    card_url: null,
    number: {
        id: '1a',
        number_generator_id: '2b',
        persona_id: 1,
        number: 'TEST-1',
    },
    membership_providers: [{
            service_name: 'clare_accounting',
            provider_type: 'Order',
            provider_id: 'ABCD1234',
            clare_item_variation_uuid: 'x',
        }],
    membership_affiliation_path: [{
            organization_id: mocks_1.orgClub.id,
            organization_name: mocks_1.orgClub.name,
            classification: 'Club',
        },
        {
            organization_id: mocks_1.orgNgb.id,
            organization_name: mocks_1.orgNgb.name,
            classification: null
        }
    ],
    persona: exports.membershipPersonaFactory.build(),
    audit_logs: []
});
